import {
  PENDING_DEBRIEF_SURVEY,
  DEBRIEF_SURVEY,
  ADD_EMPLOYEE_TO_DEBRIEF_SURVEY,
  VERIFY_EMPLOYEE_SURVEY,
  PENDING_VERIFY_EMPLOYEE,
  CLEAR_DEBRIEF_SURVEY,
} from "constants/actions";

const initialState = {
  pending: false,
  debrief_survey: {},
  employee_added: false,
  verify_response: null,
  verify_pending: false,
};

export default function DebriefSurvey(state = initialState, action) {
  switch (action.type) {
    case PENDING_DEBRIEF_SURVEY:
      return {
        ...state,
        pending: true,
      };

    case DEBRIEF_SURVEY:
      return {
        ...state,
        pending: false,
        debrief_survey: action.payload,
      };
    case ADD_EMPLOYEE_TO_DEBRIEF_SURVEY:
      return {
        ...state,
        pending: false,
        employee_added: action.payload,
      };
    case PENDING_VERIFY_EMPLOYEE:
      return {
        ...state,
        verify_pending: true,
      };
    case VERIFY_EMPLOYEE_SURVEY:
      return {
        ...state,
        verify_pending: false,
        verify_response: action.payload,
      };
    case CLEAR_DEBRIEF_SURVEY:
      return {
        ...state,
        pending: false,
        debrief_survey: {},
        verify_response: null,
        verify_pending: false,
      };

    default:
      return state;
  }
}
